import { Component } from '@angular/core';
import { AccountMaintenanceMessagesService } from '../shared/services/account-maintenance-messages.service';

@Component({
  selector: 'app-account-maintenance',
  styleUrls: [ './account-maintenance.component.scss' ],
  templateUrl: './account-maintenance.component.html',
  standalone: false
})
export class AccountMaintenanceComponent {
  public constructor(
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    public messagesService: AccountMaintenanceMessagesService
  ) {}
}

